import { Descriptions, Image, Input, Tag, Typography } from "antd";
import classes from "./UserInfo.module.scss";
import { FallbackImage } from "../../../../generic components/ImageWithfallback/ImageWithfallback";
const { Text } = Typography;

export const UserInfoComponent = ({ record }) => {
  return (
    <div className={classes.user_info}>
      <div className={classes.user_info__head}>
        <div className={classes.user_info__head__image}>
          <FallbackImage src={record.image} alt={record.fullName} width={96} />
        </div>

        <div className={classes.user_info__head__data}>
          <div className={classes.user_info__head__data__content}>
            {record.email && (
              <Typography>
                <span style={{ fontWeight: "700" }}>Email:</span>
                <Text copyable> {record.email}</Text>
              </Typography>
            )}
            {record.address && (
              <Typography>
                <span style={{ fontWeight: "700" }}>Address:</span>
                <Text copyable>{record.address}</Text>
              </Typography>
            )}
            {record.phoneNO && (
              <Typography>
                <span style={{ fontWeight: "700" }}>Phone:</span>
                <Text copyable> {record.phoneNO}</Text>
              </Typography>
            )}
            {record.nationality && (
              <Typography>
                <span style={{ fontWeight: "700" }}>Nationality:</span>
                <Text copyable> {record.nationality}</Text>
              </Typography>
            )}
          </div>
          <div className={classes.user_info__head__data__tags}>
            <Descriptions.Item label="Verified">
              {record.verified ? (
                <Tag color="green">Verified</Tag>
              ) : (
                <Tag color="red">Unverified</Tag>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Verified">
              {record.isAdmin ? (
                <Tag color="green">Admin</Tag>
              ) : (
                <Tag color="red">Not Admin</Tag>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Verified">
              {record.travelledBefore ? (
                <Tag color="green">Travelled Before</Tag>
              ) : (
                <Tag color="red">Didn't Travel Before</Tag>
              )}
            </Descriptions.Item>
          </div>
        </div>
      </div>

      <div className={classes.user_info__inputs}>
        <div className={classes.user_info__inputs__input_wrapper}>
          <Typography.Title level={5}>Gender</Typography.Title>
          <Input disabled value={record.gender} />
        </div>
        <div className={classes.user_info__inputs__input_wrapper}>
          <Typography.Title level={5}>Points</Typography.Title>
          <Input disabled value={record.points} />
        </div>
        <div className={classes.user_info__inputs__input_wrapper}>
          <Typography.Title level={5}>Profession</Typography.Title>
          <Input disabled value={record.profession} />
        </div>
        <div className={classes.user_info__inputs__input_wrapper}>
          <Typography.Title level={5}>National ID</Typography.Title>
          <Input disabled value={record.nationalId} />
        </div>
        <div className={classes.user_info__inputs__input_wrapper}>
          <Typography.Title level={5}>Birth Date</Typography.Title>
          <Input
            disabled
            value={new Date(record.birthDate).toLocaleDateString()}
          />
        </div>
      </div>
    </div>
  );
};
